export const defaultConfig = {
  recentChanges: {},
  meta: {},
  categories: {},
  localities: {},
  selects: {},
  structures: {},
  orgGroups: {},
  orgAdmin: {},
  orgUtilities: {}
}



// WEBPACK FOOTER //
// ./src/components/config/config.js